import {ErrorModel} from '../../models';
import {DAO_CODE} from './_daoCode';
import axios from 'axios';
import sortByName from '../../utils/sortByName';
import {URL} from '../root';
const FUNCTION_CODE = 'GET_ALL_DEAL_DAS';

export async function getAllDealDas(
    userToken: string,
    params: string,
    page: number | null | undefined,
) {
    
    try {

        const response = await axios.get(
            `${URL}/deal-das/?page=${page}&page_size=2000&order=name&active=true&order=name${params}`,
            {
                headers: {
                    Accept: 'application/json',
                    Authorization: `Token ${userToken}`
                }
            },
        );

        const sortedResult =  sortByName(response.data.results);

        return {...response.data, results: sortedResult};
    }
    catch (error) {
        throw ErrorModel.newError({
            code: `${DAO_CODE}/${FUNCTION_CODE}/ERROR`,
            message: 'Une erreur est survenue lors de la récupération de la liste des domaines d\'activités des affaires',
            error: error
        });
    }
}
